import { ActionStatus } from '@/application/types';
import { ProductSearchState } from '../types';

export const productSearchStateDefaults: ProductSearchState = {
  hasSearchBeenTriggered: false,
  hasSearchResultedIn0Results: false,
  lastSearchType: 'ean',
  lastSearchTerm: '',
  currentProductId: null,
  currentProductIdentification: null,
  currentProductMasterData: null,
  currentProductOrders: null,
  currentProductRelatedCalendars: null,
  currentProductRelatedSPPs: null,
  currentProductRawImport: null,
  currentProductDataDistribution: null,
  productIdentifications: [],
  getProductIdentificationsByEANStatus: ActionStatus.None,
  getProductIdentificationsByProjectNumberStatus: ActionStatus.None,
  getProductIdentificationStatus: ActionStatus.None,
  getProductMasterDataStatus: ActionStatus.None,
  getProductDataDistributionStatus: ActionStatus.None,
  getProductOrdersStatus: ActionStatus.None,
  getProductRelatedCalendarsStatus: ActionStatus.None,
  getProductRelatedSPPsStatus: ActionStatus.None,
  getProductRawImportStatus: ActionStatus.None,
};
